import Hero from './components/Hero';
import Features from './components/Features';
import UseCases from './components/UseCases';
import ServiceFlow from './components/ServiceFlow';
import Pricing from './components/Pricing';
import DeliveryInfo from './components/DeliveryInfo';
import Footer from './components/Footer';
import ContactForm from './components/ContactForm';
import AlertModal from './components/AlertModal';

import { useState } from 'react';

export default function Home() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const openContactForm = () => {
    setIsContactFormOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <Hero onOpenContactForm={openContactForm} />
      <Features onOpenContactForm={openContactForm} />
      <ServiceFlow />
      <UseCases onOpenContactForm={openContactForm} />
      <Pricing />
      <DeliveryInfo />
      <Footer />
      
      {/* 下部固定ボタン */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-center">
          <button
            onClick={openContactForm}
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#eb4b3f] to-[#f0945b] text-white text-base font-semibold rounded-full hover:from-[#d43d31] hover:to-[#e08549] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-right-circle-line mr-2 text-xl"></i>
            キーワード検索を利用する
          </button>
        </div>
      </div>
      
      <ContactForm 
        isOpen={isContactFormOpen}
        onClose={() => setIsContactFormOpen(false)}
        setIsAlertOpen={setIsAlertOpen}
      />

      <AlertModal isOpen={isAlertOpen} onClose={() => setIsAlertOpen(false)} />
    </div>
  );
}
